import { z } from 'zod';
export const syncActionPriorities = ['P0', 'P1', 'P2', 'P3'];
export const syncActionTaskStatuses = [
    'open',
    'acknowledged',
    'suppressed',
    'in_progress',
    'fixed',
    'failed',
];
export const syncActionFixModes = [
    'autonomous_safe',
    'assisted',
    'manual',
];
export const syncActionEventTypes = [
    'task_created',
    'task_updated',
    'remediation_started',
    'pipeline_run_created',
    'pr_opened',
    'validation_started',
    'validation_passed',
    'validation_failed',
    'task_resolved',
    'task_failed',
];
export const syncActionPrioritySchema = z.enum(syncActionPriorities);
export const syncActionTaskStatusSchema = z.enum(syncActionTaskStatuses);
export const syncActionFixModeSchema = z.enum(syncActionFixModes);
export const syncActionEventTypeSchema = z.enum(syncActionEventTypes);
export const syncActionEventSchema = z.object({
    type: syncActionEventTypeSchema,
    message: z.string().min(1).max(1000),
    at: z.coerce.date(),
    metadata: z.record(z.unknown()).optional(),
});
export const syncActionableTaskSchema = z.object({
    id: z.string().min(1),
    // #989: task/run is the authoritative subscriber-facing parent. Project is
    // optional grouping context and may be linked later.
    tenant_id: z.string().min(1).optional(),
    task_id: z.string().min(1).optional(),
    project_id: z.string().min(1).nullable().optional(),
    sync_run_id: z.string().optional(),
    // #989: exact producing Forge phase and immutable source provenance.
    phase_id: z.string().min(1).optional(),
    source_finding_id: z.string().min(1).optional(),
    source_finding_hash: z.string().regex(/^[a-f0-9]{64}$/i).optional(),
    evidence_refs: z.array(z.string().min(1)).default([]),
    priority: syncActionPrioritySchema,
    status: syncActionTaskStatusSchema.default('open'),
    title: z.string().min(1).max(500),
    description: z.string().min(1).max(8000),
    file_path: z.string().optional(),
    category: z.string().min(1),
    severity: z.enum(['critical', 'high', 'medium', 'low', 'info']),
    fix_mode: syncActionFixModeSchema,
    autonomous_fix_available: z.boolean(),
    recommended_action: z.string().min(1).max(8000),
    source_finding: z.record(z.unknown()),
    events: z.array(syncActionEventSchema).default([]),
    last_event_type: syncActionEventTypeSchema.optional(),
    last_event_message: z.string().max(1000).optional(),
    suppression_reason: z.string().max(2000).optional(),
    remediation_run_id: z.string().optional(),
    remediation_pr_number: z.number().int().positive().optional(),
    created_at: z.coerce.date().optional(),
    updated_at: z.coerce.date().optional(),
});
export const syncActionableTaskPatchSchema = z.object({
    status: syncActionTaskStatusSchema.optional(),
    suppression_reason: z.string().max(2000).optional(),
    remediation_run_id: z.string().optional(),
    remediation_pr_number: z.number().int().positive().nullable().optional(),
    event: syncActionEventSchema.optional(),
    updated_at: z.coerce.date().optional(),
});
export const syncActionableTaskSummarySchema = z.object({
    total: z.number().int().min(0),
    autonomous_fix_available: z.number().int().min(0),
    by_priority: z.record(z.number().int().min(0)),
    by_status: z.record(z.number().int().min(0)),
    latest_event_at: z.coerce.date().optional(),
    top_tasks: z.array(z.object({
        id: z.string(),
        priority: syncActionPrioritySchema,
        status: syncActionTaskStatusSchema,
        title: z.string(),
        file_path: z.string().optional(),
        fix_mode: syncActionFixModeSchema,
        last_event_type: syncActionEventTypeSchema.optional(),
        last_event_message: z.string().optional(),
    })),
});
export function parseSyncActionableTask(input) {
    return syncActionableTaskSchema.parse(input);
}
export function parseSyncActionableTaskPatch(input) {
    return syncActionableTaskPatchSchema.parse(input);
}
export function parseSyncActionableTaskSummary(input) {
    return syncActionableTaskSummarySchema.parse(input);
}
//# sourceMappingURL=sync-actionable-task.js.map